import React from "react";
import styles from "./HeroSection.module.scss";
import assets from "../../assets";
export default function HeroSlide({ img, headerText, description, scrollDown }) {
  return (
    <div className={` ${styles.heroSlide}`}>
      <img className={styles.heroSlideImage} src={img} loading="lazy" alt={headerText} />
      <div className={`container ${styles.heroTextWrapper}`}>
        <h2>{headerText}</h2>
        <p>{description}</p>
        <a href="#about">
          <img src={assets.icons.scroll} alt="scroll down" />
          <span>
            {scrollDown}
          </span>
        </a>
      </div>
    </div>
  );
}
